export const isOutOfArena = ref => {
  const outFromLeft = ref.current.position.x > 7.5
  const outFromRight = ref.current.position.x < -7.5
  const outFromTop = ref.current.position.z < -7.5
  const outFromBottom = ref.current.position.z > 7.5
  return outFromLeft || outFromRight || outFromTop || outFromBottom
}
